/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Modal, Table, Button, Spin } from 'antd'
import { SelectOutlined, DeleteOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'

import { onListCustomerVatInvoiceByCustomerName } from 'redux/actions'
import { addCommas } from 'utils'

import InlineInput from 'components/InlineInput'

const SearchCustomerVatInvoicePopup = ({
  visible,
  onClick,
  onCancel,
  onDeleteItem,
  customerName = '',
}) => {
  const [list, setList] = useState([])
  const [name, setName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [filteredList, setFilteredList] = useState([])
  const dispatch = useDispatch()
  let listCustomerVatInvoiceByCustomerName = useSelector(
    (state) => state.listCustomerVatInvoiceByCustomerName
  )

  useEffect(() => {
    if (visible && customerName !== '') {
      dispatch(onListCustomerVatInvoiceByCustomerName(customerName))
    }
    setName(customerName)
  }, [visible])

  useEffect(() => {
    const { error, loading, finished, data, trace } =
    listCustomerVatInvoiceByCustomerName
    if (!error && !loading && finished) {
      setList(data)
      setFilteredList(data)
      setIsLoading(false)
    }
    if (error && !loading) {
      Modal.error({
        centered: true,
        title: 'ตรวจสอบ',
        content: `${trace.message}`,
      })
      setIsLoading(false)
    }
  }, [listCustomerVatInvoiceByCustomerName])

  const handleSearch = (searchValue) => {
    const _list = [...list]
    const filteredData = _list.filter(
      ({ customer_invoice_no, customer_name }) => {
        customer_invoice_no = customer_invoice_no.toString().toLowerCase()
        customer_name = customer_name.toString().toLowerCase()
        return (
          customer_invoice_no.includes(searchValue.toLowerCase()) ||
          customer_name.includes(searchValue.toLowerCase())
        )
      }
    )
    setFilteredList(filteredData)
  }

  const fetchList = (value) => {
    setIsLoading(true)
    dispatch(onListCustomerVatInvoiceByCustomerName(value))
  }

  const onClosePopUp = () => {
    clearInput()
    onCancel()
  }

  const onSelectItem = (record) => {
    onClick(record)
    // clearInput()
  }

  const clearInput = () => {
    setList([])
    setFilteredList([])
    setSearchText('')
  }

  const tableColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '30px',
      render: (_, record) => {
        return (
          <Button
            size="small"
            type="primary"
            icon={<SelectOutlined />}
            onClick={() => onSelectItem(record)}
          />
        )
      },
    },
    {
      title: 'เลขที่ใบวางบิล',
      dataIndex: 'customer_invoice_no',
      key: 'customer_invoice_no',
      width: '170px',
    },
    {
      title: 'วันที่ซื้อ',
      dataIndex: 'date',
      key: 'date',
      width: '100px',
    },
    {
      title: 'ชื่อผู้ขาย',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: '250px',
      render: (text) => <div className="break-word">{text}</div>,
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'customer_invoice_total',
      key: 'customer_invoice_total',
      width: '110px',
      render: (text) => (
        <div className="text-align-right pr-2">{addCommas(text)}</div>
      ),
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '40px',
      render: (_, record) => {
        return (
          <Button
            size="small"
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => onDeleteItem(record)}
          />
        )
      },
    },
  ]

  return (
    <Modal
      visible={visible}
      width="900px"
      onCancel={onClosePopUp}
      footer={null}
      title={
        <div>
          <InlineInput
            onSearch={(value) => {
              fetchList(value)
            }}
            inputOption="search"
            label="ค้นจาก"
            placeholder="ใส่ชื่อลูกค้า"
            disabled
            value={name}
            width="280px"
            onChange={(event) => {
              setName(event.target.value.toUpperCase())
            }}
          />
        </div>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          rowKey={(record) => `id+${record.code}`}
          dataSource={filteredList}
          columns={tableColumns}
          style={{ height: '440px' }}
          scroll={{ y: 360 }}
          size="small"
          pagination={{
            position: ['bottomRight'],
            simple: true,
            defaultPageSize: 10,
          }}
        />
        <div style={{ position: 'absolute', bottom: '-8px' }}>
          <div className="mb-1">
            <InlineInput
              onSearch={(value) => {
                handleSearch(value)
              }}
              inputOption="search"
              label="กรองข้อมูล"
              placeholder="กรอง เลขที่ใบวางบิล"
              value={searchText}
              width="280px"
              onChange={(event) => {
                setSearchText(event.target.value.toUpperCase())
              }}
            />
          </div>
        </div>
      </Spin>
    </Modal>
  )
}

export default SearchCustomerVatInvoicePopup
